// Get the utility bar element
const utilityBar = document.querySelector(".utility-bar");

window.addEventListener("scroll", function () {
  // Check if the scroll position is greater than or equal to 50 pixels
  if (window.scrollY >= 50) {
    utilityBar.classList.add("scrolled");
  } else {
    utilityBar.classList.remove("scrolled");
  }
});
